import React from 'react';
import { connect } from 'react-redux';

import {
    COOKIE_ACCEPTED_KEY,
    COOKIE_ACCEPTED_VALUE
} from '../../../services/header/cookiebanner/constants';
import { PATH } from '../../../constants/path';
import ButtonComponent from '../../button/ButtonComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';
import { hideBanner } from '../../../services/banner/actions';
import { BANNER_TYPE_COOKIE } from '../../../services/banner/constants';

import './CookieBannerComponent.scss';

class CookieBannerComponent extends React.Component {
    hideCookieBanner = () => this.props.hideBanner(BANNER_TYPE_COOKIE);

    setCookie = () => {
        localStorage.setItem(COOKIE_ACCEPTED_KEY, COOKIE_ACCEPTED_VALUE);
        this.hideCookieBanner();
    };

    isCookiesAccepted = () => {
        const cookieValue = localStorage.getItem(COOKIE_ACCEPTED_KEY);
        return cookieValue === COOKIE_ACCEPTED_VALUE ? true : false;
    };

    render() {
        const { i18n } = this.props;

        return (
            !this.isCookiesAccepted() && (
                <div id="b-cookie">
                    <div className="conteneur conteneur-mobile">
                        {i18n.TEXT}
                        <LocalizedNavLink
                            to={`${PATH.LEGAL_NOTICE_PATH}#cookie-policy`}
                            title={i18n.LINK_TEXT}
                            className="link">
                            {i18n.LINK_TEXT}
                        </LocalizedNavLink>
                        <ButtonComponent
                            text={i18n.BUTTON_TEXT}
                            color="second"
                            onClick={this.setCookie}
                        />
                    </div>
                </div>
            )
        );
    }
}

const mapDispatchToProps = {
    hideBanner
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.COOKIE_BANNER
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CookieBannerComponent);



// WEBPACK FOOTER //
// ./src/components/header/cookiebanner/CookieBannerComponent.js